export default __webpack_public_path__ + "static/media/msort_arr_td.145985cd.md";